import React from "react";

const ReunionDashboardHero = ({ event }) => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-br from-emerald-950 via-teal-950 to-purple-950 border-b border-emerald-500/20">
      {/* Background Glow */}
      <div className="absolute inset-0 bg-[radial-gradient(at_15%_20%,rgba(16,185,129,.18),transparent_60%)]"></div>
      <div className="absolute inset-0 bg-[radial-gradient(at_85%_80%,rgba(168,85,247,.15),transparent_60%)]"></div>

      <div className="relative max-w-7xl mx-auto px-4 py-8">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 rounded-full border border-white/15 bg-white/10 backdrop-blur-md px-5 py-2 mb-6">
          <span className="text-xl">🫂</span>
          <span className="uppercase tracking-[0.28em] text-xs text-emerald-200 font-semibold">
            Think5Whys • PurpleDoor • Reunion
          </span>
        </div>

        {/* Title */}
        <h1 className="text-2xl lg:text-4xl font-black text-white mb-2">
          Reunion Organizer Dashboard
        </h1>

        <p className="text-emerald-100/80 text-sm lg:text-lg mb-8">
          Manage your live event, monitor participation and celebrate winners.
        </p>

        {/* Summary */}
        <div className="grid gap-4 lg:grid-cols-4">
          {/* Event */}
          <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md p-5">
            <div className="text-3xl mb-3">🏛️</div>

            <div className="text-xs uppercase tracking-widest text-emerald-300 mb-2">
              Event
            </div>

            <div className="font-bold text-lg">{event.hallName}</div>

            <div className="text-xs text-emerald-200 mt-2">Session ID</div>

            <div className="font-mono text-sm text-white">
              {event.subscriptionId}
            </div>
          </div>

          {/* Participants */}
          <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md p-5">
            <div className="text-3xl mb-3">👥</div>

            <div className="text-xs uppercase tracking-widest text-emerald-300 mb-2">
              Participants
            </div>

            <div className="text-3xl font-black">
              {event.participantsJoined}
            </div>

            <div className="text-sm text-emerald-200 mt-2">
              of {event.entryPassCount} Entry Passes
            </div>
          </div>

          {/* Quiz */}
          <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md p-5">
            <div className="text-3xl mb-3">📊</div>

            <div className="text-xs uppercase tracking-widest text-emerald-300 mb-2">
              Quiz Progress
            </div>

            <div className="flex justify-between text-sm mb-2">
              <span>Answers</span>
              <span>{event.answersSubmitted}</span>
            </div>

            <div className="flex justify-between text-sm">
              <span>Correct</span>
              <span>{event.correctAnswers}</span>
            </div>
          </div>

          {/* Status */}
          <div className="rounded-3xl border border-white/10 bg-white/5 backdrop-blur-md p-5">
            <div className="text-3xl mb-3">{event.isLive ? "🟢" : "🟡"}</div>

            <div className="text-xs uppercase tracking-widest text-emerald-300 mb-2">
              Event Status
            </div>

            <div className="text-xl font-bold">{event.status}</div>

            <div
              className={`mt-4 inline-flex px-4 py-1 rounded-full text-sm font-semibold ${
                event.isLive
                  ? "bg-green-500/20 text-green-300"
                  : "bg-yellow-500/20 text-yellow-300"
              }`}
            >
              {event.isLive ? "LIVE NOW" : "NOT LIVE"}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ReunionDashboardHero;
